var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-2"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$emit('homologarAdjudicarItemLote')}}},[_vm._v("Adjudicar/Homologar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }